import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "googleDrive",
  "name": "Google Drive",
  "category": "integrations",
  "description": "Access files and folders in Google Drive",
  "icon": "siGoogledrive",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "3.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Google Drive",
    "color": "#4285f4"
  },
  "credentials": [
    {
      "name": "googleDriveOAuth2",
      "required": true,
      "displayName": "Google Drive OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "google",
    "drive",
    "storage",
    "files",
    "cloud"
  ],
  "comingSoon": true
};

export default definition;
